import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { ThemeContext } from "../../context/ThemeStore";
import { useDispatch } from "react-redux";
import { setTheme, toggleDarkTheme } from "../../redux/slices/userSlice";

const SESSION_DARK_THEME_KEY = "quizrr_dashboard_isDarkTheme";
const USER_PROFILE_STORAGE_KEY = "userProfile";

const ChangeTheme = ({ isInlineSwitch = false, isLms = false }) => {
  const { user, setUser, isDarkTheme, setIsDarkTheme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const onThemeChange = async () => {
    const newIsDarkThemeValue = !isDarkTheme;

    const root = window.document.documentElement;
    root.classList.remove("dark", "light");
    if (newIsDarkThemeValue) {
      root.classList.add("dark");
    } else {
      root.classList.add("light");
    }

    // if (user) {
    try {
      const response = await axios.patch(`/api/user/profile/settings`, { isDarkTheme: newIsDarkThemeValue });
      if (response?.status === 200) {
        localStorage.setItem(USER_PROFILE_STORAGE_KEY, JSON.stringify(response.data.data));
      }
    } catch (err) {
      console.error("ChangeTheme: Failed to update theme setting on backend:", err);
    }
    // }

    setIsDarkTheme(newIsDarkThemeValue);
    dispatch(setTheme(newIsDarkThemeValue));
    sessionStorage.setItem(SESSION_DARK_THEME_KEY, newIsDarkThemeValue.toString());
  };

  useEffect(() => {
    const initializeTheme = async () => {
      const localUser = JSON.parse(localStorage.getItem(USER_PROFILE_STORAGE_KEY));

      let initialDarkTheme = false;
      const root = window.document.documentElement;
      if (root.classList.contains("dark")) {
        initialDarkTheme = true;
      } else if (localUser?.settings?.isDarkTheme !== undefined) {
        initialDarkTheme = localUser.settings.isDarkTheme;
      }

      if (isLms) {
        try {
          const response = await axios.patch(`/api/user/profile/settings`, { isDarkTheme: false });
          if (response?.status === 200) {
            setUser(response.data.data);
            localStorage.setItem(USER_PROFILE_STORAGE_KEY, JSON.stringify(response.data.data));
            sessionStorage.setItem(USER_PROFILE_STORAGE_KEY, JSON.stringify(response.data.data)); // Corrected `req.data?.data?.user`
            initialDarkTheme = false;
          }
        } catch (err) {
          console.log(err);
        }
      }

      setIsDarkTheme(initialDarkTheme);
      dispatch(setTheme(initialDarkTheme));
    };

    initializeTheme();
  }, [isLms, setIsDarkTheme, dispatch, setUser]); // Added setUser to dependencies for completeness

  useEffect(() => {
    if (isDarkTheme !== undefined) {
      const root = window.document.documentElement;
      root.classList.remove("dark", "light");
      if (isDarkTheme) {
        root.classList.add("dark");
      } else {
        root.classList.add("light");
      }
    }
  }, [isDarkTheme]);

  return (
    <div>
      <div>
        {!isLms && (
          <label
            id="switch"
            className={`switch ${isInlineSwitch ? "switch-inline" : "d-none d-md-inline-block"}`}
            style={{ zIndex: 10000 }}
          >
            <input type="checkbox" id="slider" checked={!isDarkTheme} onChange={onThemeChange} />
            <span className="slider round"></span>
          </label>
        )}
      </div>
    </div>
  );
};

export default ChangeTheme;
